import Counter from '../Counter';

const StatCard = ({ stat, isVisible }) => (
  <div className="stat-card">
    <div className="stat-icon">{stat.icon}</div>
    <div className="stat-value">
      <Counter end={stat.value} suffix={stat.suffix} isVisible={isVisible} />
    </div>
    <div className="stat-label">{stat.label}</div>
  </div>
);

export default StatCard;
